module.exports = __webpack_public_path__ + "img/footer_04_brandk.f7249605.png";